'use strict';

var React = require('react');
var injectSheet = require('react-jss');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var jssMixins = require('pobble-components/dist/jss-mixins');
var THEME = require('pobble-components/dist/theme');
var classNames = require('classnames');
var Button = require('pobble-components/dist/button');
var pageMonsterWally = require('pobble-components/dist/page-not-found/page-monster-wally.png');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var injectSheet__default = /*#__PURE__*/_interopDefaultLegacy(injectSheet);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var THEME__default = /*#__PURE__*/_interopDefaultLegacy(THEME);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var pageMonsterWally__default = /*#__PURE__*/_interopDefaultLegacy(pageMonsterWally);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var COLORS = THEME__default["default"].COLORS,
    FONT_SIZES = THEME__default["default"].FONT_SIZES;
var styles = {
  container: _objectSpread(_objectSpread({}, jssMixins.fullVHExceptHeader), {}, {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }),
  holder: _defineProperty__default["default"]({
    display: 'flex',
    alignItems: 'center'
  }, "@media (max-width: 1023px)", {
    flexDirection: 'column'
  }),
  img: _defineProperty__default["default"]({
    width: '320px',
    height: '320px',
    margin: '0 0 0 50px'
  }, "@media (max-width: 1023px)", {
    margin: '0',
    order: '1',
    width: '250px',
    height: '250px'
  }),
  descHolder: _objectSpread(_objectSpread({
    color: COLORS.TEXT.DARK_GREY.NORMAL
  }, FONT_SIZES.BODY_LARGE.STYLE), {}, _defineProperty__default["default"]({
    textAlign: 'center',
    maxWidth: '300px'
  }, "@media (max-width: 1023px)", {
    order: '2'
  })),
  title: _objectSpread(_objectSpread({
    color: COLORS.DARK_BLUE.NORMAL,
    fontWeight: 'bold'
  }, FONT_SIZES.HEADING_LARGE.STYLE), {}, {
    margin: '0 0 12px'
  }),
  paragraph: {
    margin: '0 0 18px'
  },
  status: {
    position: 'absolute',
    right: '20px',
    top: '20px',
    fontSize: '100px',
    fontWeight: 'bold',
    lineHeight: '1',
    margin: '0',
    color: '#ddd'
  }
};

var PageNotFound = function PageNotFound(_ref) {
  var classes = _ref.classes,
      className = _ref.className;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: classNames__default["default"](classes.container, className)
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: classes.holder
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: classes.descHolder
  }, /*#__PURE__*/React__default["default"].createElement("h2", {
    className: classes.title
  }, "This page doesn't", /*#__PURE__*/React__default["default"].createElement("br", null), "seem to exist"), /*#__PURE__*/React__default["default"].createElement("p", {
    className: classes.paragraph
  }, "Our page monster", /*#__PURE__*/React__default["default"].createElement("br", null), "gets hungry sometimes."), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    tall: true,
    href: "/lessons/prompt"
  }, "Get back to Pobble"), /*#__PURE__*/React__default["default"].createElement("p", {
    className: classes.status
  }, "404")), /*#__PURE__*/React__default["default"].createElement("img", {
    className: classes.img,
    src: pageMonsterWally__default["default"],
    alt: "Page monster Wally"
  })));
};

var index = injectSheet__default["default"](styles)(PageNotFound);

module.exports = index;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// /codebuild/output/src2416834937/src/pobble-app/client/~/pobble-components/dist/page-not-found/index.js